import { type ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

// Matches the loaded layout exactly (title, 132px ring, four legend rows)
// so the crossfade does not shift anything on the page.
function DonutSkeleton(): ReactNode {
  return (
    <div className="space-y-md">
      <Skeleton className="h-[13px] w-20" />
      <div className="flex items-center gap-base">
        <Skeleton className="h-[132px] w-[132px] shrink-0 rounded-full" />
        <div className="min-w-0 max-w-[15rem] flex-1 space-y-sm">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-[13px] w-full" />
          ))}
        </div>
      </div>
    </div>
  );
}

export function DistributionSkeleton(): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-lg sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <DonutSkeleton key={i} />
      ))}
    </div>
  );
}
